// extracted by mini-css-extract-plugin
export var label = "_dv-1";
export var reminder = "_dv-0";